__turbopack_context__.v({
  "__active": "PanoramaModal-module-scss-module__hBjRvq____active",
  "compass": "PanoramaModal-module-scss-module__hBjRvq__compass",
  "panoramaMinBack": "PanoramaModal-module-scss-module__hBjRvq__panoramaMinBack",
  "panoramaModal": "PanoramaModal-module-scss-module__hBjRvq__panoramaModal",
  "panoramaModalBtn": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalBtn",
  "panoramaModalBtnClose": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalBtnClose",
  "panoramaModalBtnCloseText": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalBtnCloseText",
  "panoramaModalBtnsBox": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalBtnsBox",
  "panoramaModalClose": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalClose",
  "panoramaModalContainer": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalContainer",
  "panoramaModalContainer_three": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalContainer_three",
  "panoramaModalContainer_two": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalContainer_two",
  "panoramaModalPlug": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalPlug",
  "panoramaModalWrapper": "PanoramaModal-module-scss-module__hBjRvq__panoramaModalWrapper",
});
